export default __webpack_public_path__ + "static/media/bspring27.fb574a44.webp";